import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    fullName: '',
    headPic: '',
    firstName: '',
    lastName: '',
    meetingUrl: '',
    phoneNumber: '',
    roleTitle: '',
    reasonForMortgage: '',
};

const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        alterUserInfo(state, action) {
            if (action.payload.fullName) state.fullName = action.payload.fullName;
            if (action.payload.headPic) state.headPic = action.payload.headPic;
            if (action.payload.firstName) state.firstName = action.payload.firstName;
            if (action.payload.lastName) state.lastName = action.payload.lastName;
            if (action.payload.meetingUrl) {
                state.meetingUrl = action.payload.meetingUrl;
                console.log('ssss');
            }
            if (action.payload.phoneNumber) state.phoneNumber = action.payload.phoneNumber;
            if (action.payload.roleTitle) state.roleTitle = action.payload.roleTitle;
        },
    },
});

export const { alterUserInfo } = userInfoSlice.actions;

export default userInfoSlice.reducer;
